var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { hideApplicationLoader, } from 'common/ApplicationLoader';
import { getCurrentSenior } from 'globals/global.functions';
import { getUserAssessmentStatusService, getSupervisionAssessmentStatusService, } from 'services/assessmentService/assessmentStatusService/assessmentStatus.service';
import { showError } from 'store/commonReducer/common.action';
export var UPDATE_ASSESSMENT_STATUS = 'UPDATE_ASSESSMENT_STATUS';
export var RESET_ASSESSMENT_STATUS = 'RESET_ASSESSMENT_STATUS';
export var UPDATE_QUESTIONNAIRE_STATUS = 'UPDATE_QUESTIONNAIRE_STATUS';
export var RESET_QUESTIONNAIRE_STATUS = 'RESET_QUESTIONNAIRE_STATUS';
/**
 * @function getAssessmentStatus
 * @description  action creator to fetch all assessment statuses
 */
export var getAssessmentStatus = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, seniorID, accountID, _b, userResponse, supervisionResponse, payload, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getCurrentSenior(), seniorID = _a.seniorID, accountID = _a.accountID;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.all([
                        getUserAssessmentStatusService({
                            senior_id: seniorID,
                            account_id: accountID,
                        }),
                        getSupervisionAssessmentStatusService({
                            senior_id: seniorID,
                            account_id: accountID,
                        }),
                    ])];
            case 2:
                _b = _c.sent(), userResponse = _b[0], supervisionResponse = _b[1];
                payload = __assign(__assign({}, userResponse), supervisionResponse);
                dispatch(hideApplicationLoader());
                // Updating global AssessmentStatus
                dispatch({
                    type: UPDATE_ASSESSMENT_STATUS,
                    payload: payload,
                });
                return [3 /*break*/, 4];
            case 3:
                error_1 = _c.sent();
                dispatch(hideApplicationLoader());
                dispatch(showError(error_1));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/**
 * @function resetAssessmentStatus
 * @description  action creator to reset all assessment statuses
 */
export var resetAssessmentStatus = function () { return function (dispatch) {
    dispatch({
        type: RESET_ASSESSMENT_STATUS,
    });
}; };
